<template>
  <b-form class="payout-form form">
    <div class="form__section mb-0">
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.account_name"
              type="text"
              required
              autofocus
              :disabled="form.$busy"
              :is-invalid="form.$getError('account_name')"
              placeholder="Account Holder Name"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="9">
          <b-form-group>
            <custom-input
              v-model="form.account_number"
              v-mask="'#########'"
              type="text"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('account_number')"
              placeholder="Account Number"
            ></custom-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group>
            <custom-input
              v-model="form.account_bsb"
              v-mask="'######'"
              type="text"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('account_bsb')"
              placeholder="BSB"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <error-message
      class="mb-2"
      sign=""
      :error="form.$getError('external_account') || form.$errorMessage"
    ></error-message>

    <div class="modal-footer">
      <div></div>
      <div class="modal__btns">
        <b-button variant="outline-secondary" @click="onClose"
          >Discard</b-button
        >
        <b-button
          class="btn-action"
          variant="primary"
          :disabled="form.$busy"
          @click="onSubmit"
        >
          <b-spinner small v-if="form.$busy"></b-spinner>&nbsp;Save
        </b-button>
      </div>
    </div>
  </b-form>
</template>
<script>
/**
 * ==================================================================================
 * Payout Form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import Form from '@/utils/form'
import CustomInput from '@/components/inputs/CustomInput'
import ErrorMessage from '@/components/inputs/ErrorMessage'

export default {
  components: {
    CustomInput,
    ErrorMessage
  },

  data: function () {
    return {
      form: new Form({
        account_name: null,
        account_number: null,
        account_bsb: null
      })
    }
  },

  methods: {
    ...mapActions({
      createExternalAccount: 'account/createExternalAccount',
      saveExternalAccount: 'account/saveExternalAccount',
      addAlert: 'alert/addAlert'
    }),

    reset() {
      this.form.account_name = null
      this.form.account_number = null
      this.form.account_bsb = null

      this.form.$clearErrors()
    },

    onClose() {
      this.$emit('on-close')
    },

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      await this.createExternalAccount(this.form.$data())
        .then((data) => {
          this.submitBankAccount(data.data.id)
        })
        .catch((error) => {
          const data = error.response.data.error
          if (data.message) {
            this.form.$errorMessage = data.message
          } else {
            this.form.$errorMessage =
              'Sorry, we are having trouble connecting to Stripe. Please try again later.'
          }

          this.form.$setLoading(false)
        })
    },

    async submitBankAccount(token) {
      this.form.$setLoading(true)
      await this.saveExternalAccount({
        external_account: token
      })
        .then(() => {
          this.reset()
          this.form.$setLoading(false)
          this.addAlert({
            label: 'Bank account has been added'
          })

          this.$emit('on-success')
        })
        .catch((error) => {
          this.form.$handleError(error)
          this.form.$setLoading(false)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.payout-form {
  .modal-footer {
    padding-top: 20px;
    justify-content: space-between;

    .btn {
      line-height: 27px;
      min-width: 125px;
      padding: 0.6rem 0.75rem;
    }
  }
}
</style>
